import React from 'react';

function Paginator({ totalPage, pageActual, onChange }) {

    const getPages = () => {
        const pages = [];

        const delta = 2; // páginas antes y después de la actual

        const rangeStart = Math.max(2, pageActual - delta);
        const rangeEnd = Math.min(totalPage - 1, pageActual + delta);

        pages.push(1); // siempre mostrar la primera

        if (rangeStart > 2) {
            pages.push('...');
        }

        for (let i = rangeStart; i <= rangeEnd; i++) {
            pages.push(i);
        }

        if (rangeEnd < totalPage - 1) {
            pages.push('...');
        }

        if (totalPage > 1) {
            pages.push(totalPage); // siempre mostrar la última
        }

        return pages;
    };

    const pages = getPages();

    return (
        <nav>
            <ul className="pagination justify-content-end">

                {/* Atrás */}
                <li className={pageActual === 1 ? "page-item disabled" : "page-item"}>
                    <button className="page-link" onClick={() => onChange(pageActual - 1)}>
                        Atrás
                    </button>
                </li>

                {/* Números */}
                {pages.map((page, index) => (
                    <li
                        key={index}
                        className={`page-item ${page === pageActual ? "active" : ""} ${page === '...' ? "disabled" : ""}`}
                    >
                        <button
                            className="page-link"
                            onClick={() => page !== '...' && onChange(page)}
                        >
                            {page}
                        </button>
                    </li>
                ))}

                {/* Siguiente */}
                <li className={pageActual === totalPage ? "page-item disabled" : "page-item"}>
                    <button className="page-link" onClick={() => onChange(pageActual + 1)}>
                        Siguiente
                    </button>
                </li>

            </ul>
        </nav>
    );
}

export default Paginator;